// shared/lib/errors/error-types.ts
export enum AppErrorType {
  EMAIL_ALREADY_EXISTS = "EMAIL_ALREADY_EXISTS",
  EMAIL_VERIFICATION_REQUIRED = "EMAIL_VERIFICATION_REQUIRED",
  VALIDATION_ERROR = "VALIDATION_ERROR",
  NETWORK_ERROR = "NETWORK_ERROR",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
  USER_NOT_FOUND = "USER_NOT_FOUND",
}

export class AppError extends Error {
  constructor(
    public type: AppErrorType,
    public message: string,
    public originalError?: Error,
  ) {
    super(message);
    this.name = "AppError";
  }
}

export const createAppError = (serverMessage: string): AppError => {
  switch (serverMessage) {
    case "Email already exists":
      return new AppError(AppErrorType.EMAIL_ALREADY_EXISTS, "이미 가입된 이메일입니다.");
    case "Email verification required":
      return new AppError(AppErrorType.EMAIL_VERIFICATION_REQUIRED, "이메일 인증이 필요합니다.");
    case "User not found":
      return new AppError(AppErrorType.USER_NOT_FOUND, "해당 이메일로 가입된 계정을 찾을 수 없습니다.");
    default:
      return new AppError(AppErrorType.UNKNOWN_ERROR, "알 수 없는 오류가 발생했습니다.");
  }
};
